module.exports = __webpack_public_path__ + "static/media/project2.9c535cfa.png";